module.exports = __webpack_public_path__ + "img/bild-de.34ae605.svg";